/* eslint max-classes-per-file: 0 */
import { ABaseModel, ReturnTicket } from '@pperform/pp-data-mappers';
import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import { getReturnTicket } from 'fetchers/returnTicket.fetcher';

interface ReturnTicketParams {
  shipmentPks?: any[];
  forwardShipmentPks?: any[];
  orderIds?: any[];
}

export class ReturnTicketDTO extends ABaseModel {
  shipmentPks: number[] = [];

  forwardShipmentPks: number[] = [];

  orderIds: number[] = [];
}

interface ReturnTicketObj {
  [key: string]: ReturnTicket[];
}

class ReturnTicketDTOResponse extends ABaseModel {
  shipmentPks: ReturnTicketObj = {};

  forwardShipmentPks: ReturnTicketObj = {};

  orderIds: ReturnTicketObj = {};
}

export const fetchReturnTickets = async (
  orgId: number,
  params: ReturnTicketParams,
): Promise<ReturnTicketDTOResponse> => {
  try {
    const convertedParams = ReturnTicketDTO.create({ ...params }).toApiData();
    const { data } = await getReturnTicket(orgId, convertedParams);

    const apiData = ReturnTicketDTOResponse.fromApiData(data);

    return apiData;
  } catch (error) {
    if (error instanceof APIError) {
      return ReturnTicketDTOResponse.create({
        shipmentPks: {},
        forwardShipmentPks: {},
        orderIds: {},
      });
    }
    throw error;
  }
};
